document.addEventListener('DOMContentLoaded', function () {
  var preview = new URLSearchParams(window.location.search).has('promo_preview');

  document.querySelectorAll('[data-countdown-saldi-estivi]').forEach(function (el) {
    var start = new Date(el.dataset.start).getTime();
    var end = new Date(el.dataset.end).getTime();
    var now = Date.now();

    if (preview || (now >= start && now <= end)) {
      el.classList.remove('hidden-until-active');
    }
  });
});
